var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nationality-avatar"},[_c('div',[_c('ImageLockRatio',{attrs:{"src":_vm.src,"alt":_vm.alt,"fallbackImage":_vm.fallbackImage}})],1),_c('div',[(_vm.flag)?_c('ImageLockRatio',{attrs:{"src":_vm.flag,"alt":"flag","fallbackImage":_vm.fallbackFlag}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }